// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {

  // ***CLOUD API DATA***
  api_url: 'https://admin-sanjeewa.susitk.io/api',
  auth_url: 'https://admin-sanjeewa.susitk.io/auth',
  // ***CLOUD API DATA***

  api_url_old_system: 'https://medapp.aptabas.com',
  api_handler: 'https://handler-sampath.susitk.io',

  // api_url: 'https://medadmin.susitk.io/api',
  // auth_url: 'https://medadmin.susitk.io/auth',
  // api_url: 'https://med-chamica.susitk.io/api',
  // auth_url: 'https://med-chamica.susitk.io/auth',
  production: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
